import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	progressBarWrapper: {
		display       : "flex",
		flexDirection : "column",
		gap           : "0.5rem"
	},
	progressIndicator: {
		"& > div": {
			background: `linear-gradient(to bottom, ${ theme.other.paletteNew.primaryDarkBlue } 0%,${ theme.other.paletteNew.primaryLightBlue } 100%)`

		  }
	},
	progressInfo: {
		alignSelf : "flex-end",
		fontSize  : "1.2rem",
		color     : theme.other.paletteNew.secondaryDarkGrey
	}
} ) );